<div class="b2b-login-password-form-lyntia"><login-password-form-generic :logo="logo" :next="next" :back="back"></login-password-form-generic></div>